module.exports = __webpack_public_path__ + "img/g3.6baf6e82.jpg";